import axios from 'axios'
import store from '@/store'
import { ElMessage } from 'element-plus'

const LOGIN_EXPIRED_MSG = '登录已失效，请重新登录'

// 跳过GSFMS token检查的URL 列表 
const SKIP_GSFMS_CHECK_URLS = [
  '/rame/gsfms/checkToken',
  '/rame/kingdee/checkToken',
  '/jf-tech/v1/login',
  '/rame/gsfms/login',
  '/rame/gsfms/login/code',
  '/rame/gsfms/yzm/fwz_login',
  '/rame/kingdee/login'
]

let isLoggingOut = false
let pendingKingdeeCheck = null
let pendingGsfmsCheck = null

const checkAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'https://www.ipolarx.com/api',
  timeout: 180000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

checkAxios.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  return config
})

export function getStoredUserInfo() {
  const userInfo = store.state.app.userInfo
  if (userInfo) {
    return userInfo
  }
  try {
    const stored = JSON.parse(
      localStorage.getItem('kingdee-app-storage') || '{}'
    )
    return stored?.app?.userInfo || null
  } catch {
    return null
  }
}

export function handleLoginExpired(description) {
  if (isLoggingOut) {
    return Promise.reject(new Error(description))
  }
  isLoggingOut = true
  ElMessage.error({
    message: `${description}，3秒后将自动跳转到登录页`,
    duration: 3000,
    showClose: false
  })
  return new Promise((_, reject) => {
    setTimeout(() => {
      store.dispatch('app/logout')
      reject(new Error(description))
    }, 3000)
  })
}

function isLoginExpiredResponse(res) {
  return res?.status === 'failure' && res?.description === LOGIN_EXPIRED_MSG
}

async function runKingdeeCheck() {
  const workerId = getStoredUserInfo()?.workerId
  if (!workerId) {
    return
  }
  const res = await checkAxios.post('/rame/kingdee/checkToken', { workerId })
  if (isLoginExpiredResponse(res.data)) {
    return handleLoginExpired(res.data.description)
  }
}

async function runGsfmsCheck() {
  const userInfo = getStoredUserInfo()
  const account = userInfo?.account
  const workerId = userInfo?.workerId
  if (!account || !workerId) {
    return
  }
  const res = await checkAxios.post('/rame/gsfms/checkToken', {
    account,
    workerId
  })
  if (isLoginExpiredResponse(res.data)) {
    return handleLoginExpired(res.data.description)
  }
}

export function ensureKingdeeTokenValid() {
  if (!pendingKingdeeCheck) {
    pendingKingdeeCheck = runKingdeeCheck().finally(() => {
      pendingKingdeeCheck = null
    })
  }
  return pendingKingdeeCheck
}

export function ensureGsfmsTokenValid() {
  if (!pendingGsfmsCheck) {
    pendingGsfmsCheck = runGsfmsCheck().finally(() => {
      pendingGsfmsCheck = null
    })
  }
  return pendingGsfmsCheck
}

export function shouldRunGsfmsTokenCheck(config) {
  if (config._skipTokenCheck) {
    return false
  }

  const url = config.url || ''

  if (url.includes('/rame/kingdee/')) {
    return false
  }

  if (SKIP_GSFMS_CHECK_URLS.some((path) => url.includes(path))) {
    return false
  }

  if (!localStorage.getItem('token')) {
    return false
  }

  const userInfo = getStoredUserInfo()
  if (!userInfo?.account || !userInfo?.workerId) {
    return false
  }

  return true
}

export function withKingdeeTokenCheck(requestFn) {
  return (...args) =>
    ensureKingdeeTokenValid().then(() => requestFn(...args))
}
